import {Component, OnInit} from '@angular/core';
import {LayoutService} from '../../../core/services/layout.service';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit
{
  constructor(private layoutService:LayoutService) {}
  ngOnInit() {}
}
